import UXEvents from '@enums/ux-events';

export default [
    {
        key: UXEvents.rateCardUpdated,
        actions: ['rateCards/submitRateCard'],
    },
];
